"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createLogger_1 = __importDefault(require("./createLogger"));
const bugsnagLoggerProvider = (bugsnagClient, baseLogger) => {
    return (appName, opts) => {
        const logger = baseLogger ? baseLogger.extend(opts.name) : (0, createLogger_1.default)(appName, opts);
        const actualSetContext = logger.setContextValue;
        const actualError = logger.error;
        logger.setContextValue = (key, value) => {
            bugsnagClient.leaveBreadcrumb('set-context', { [key]: value });
            actualSetContext(key, value);
        };
        logger.error = (...args) => {
            // logger doesn't enforce that an error is passed in, or what order it will be passed in,
            // so grab any error that is passed in
            let error = args.find(v => v instanceof Error);
            // if we can't find an error and the first arg is a string, use that as the error message
            const firstArgIsString = typeof args[0] === 'string';
            if (firstArgIsString && !error) {
                error = new Error(args[0]);
            }
            // the client will/should handle whether it actual sends the error to bugsnag
            bugsnagClient.notify(error, { metaData: args });
            // pass on to the actual logger
            actualError(...args);
        };
        return logger;
    };
};
exports.default = bugsnagLoggerProvider;
//# sourceMappingURL=bugsnagLoggerProvider.js.map